<template>
  <div
    class="modal fade"
    id="translateKpiDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            aria-hidden="true"
            @click="closeKpiTranslationModal()"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.KM3001 }}</b>
            <br />
          </h4>
          <h5>{{ lang.KM3008 }}: {{ client.clientName }}</h5>
        </div>
        <div class="modal-body">
          <div class="panel panel-default">
            <div class="panel-body">
              <div class="col-md-9">
                <div class="form-group">
                  <label for="selectLocale" class="col-md-3 control-label">{{
                    lang.KM3002
                  }}</label>
                  <div class="col-md-9">
                    <Select2
                      class="form-control"
                      id="selectLocale"
                      @change="selectedLocaleChanged"
                      :placeholder="lang.KM3003"
                    >
                      <option
                        v-for="locale in avaibleLocaleList"
                        :key="locale.LocaleCode"
                        :value="locale.LocaleCode"
                      >
                        {{ locale.LocaleName }}
                      </option>
                    </Select2>
                  </div>
                </div>
                <div class="form-group">
                  <label
                    for="selectKpiTranslationProject"
                    class="col-md-3 control-label"
                    >{{ lang.KM3015 }}</label
                  >
                  <div class="col-md-9">
                    <Select2
                      class="form-control"
                      id="selectKpiTranslationProject"
                      v-model="selectedProject"
                      :placeholder="lang.KM3016"
                      :allowClear="true"
                    >
                      <option></option>
                      <option
                        v-for="project in projects"
                        :key="project.ProjectGuid"
                        :value="project.ProjectGuid"
                      >
                        {{ project.ProjectName }}
                      </option>
                    </Select2>
                  </div>
                </div>
                <div class="form-group">
                  <label for="inputSearchKpi" class="col-md-3 control-label">{{
                    lang.KM3004
                  }}</label>
                  <div class="col-md-9">
                    <input
                      type="text"
                      class="form-control"
                      id="inputSearchKpi"
                      v-model="searchKpiString"
                      @keyup.enter="doFiltering()"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <button
                  type="button"
                  class="btn btn-raised btn-default"
                  @click="getInitialSort()"
                  :disabled="!selectedLocaleCode"
                >
                  {{ lang.KM3014 }}
                </button>
              </div>
            </div>
          </div>
          <div class="panel panel-default">
            <div class="panel-body">
              <table class="table table-hover main-table">
                <thead>
                  <tr>
                    <th
                      id="kpiTypeColumnHeader"
                      style="width: 14%"
                      class="text-center"
                    >
                      <a
                        class="table-header"
                        role="button"
                        @click="orderTableByColumn('Type')"
                      >
                        {{ lang.KM3005 }}
                        <span
                          v-if="showSortArrow('Type', true)"
                          v-show="isInitialSort"
                          class="glyphicon glyphicon-triangle-top"
                        ></span>
                        <span
                          v-if="showSortArrow('Type', false)"
                          v-show="isInitialSort"
                          class="glyphicon glyphicon-triangle-bottom"
                        ></span>
                      </a>
                    </th>
                    <th style="width: 43%" class="text-center">
                      <a
                        class="table-header"
                        role="button"
                        @click="orderTableByColumn('Text')"
                      >
                        {{ lang.KM3006 }}
                        <span
                          v-if="showSortArrow('Text', true)"
                          v-show="isInitialSort"
                          class="glyphicon glyphicon-triangle-top"
                        ></span>
                        <span
                          v-if="showSortArrow('Text', false)"
                          v-show="isInitialSort"
                          class="glyphicon glyphicon-triangle-bottom"
                        ></span>
                      </a>
                    </th>
                    <th style="width: 43%" class="text-center">
                      <a
                        class="table-header"
                        role="button"
                        @click="orderTableByColumn('Translation')"
                      >
                        {{ lang.KM3007 }}
                        <span
                          v-if="showSortArrow('Translation', true)"
                          v-show="isInitialSort"
                          class="glyphicon glyphicon-triangle-top"
                        ></span>
                        <span
                          v-if="showSortArrow('Translation', false)"
                          v-show="isInitialSort"
                          class="glyphicon glyphicon-triangle-bottom"
                        ></span>
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody class="main-table-scrollbar">
                  <tr
                    v-for="(kpiInformation, index) in filteredKpiTranslations"
                    v-show="
                      !selectedProject ||
                      kpiInformation.ProjectGuid === selectedProject
                    "
                    :key="index"
                    :class="{
                      'kpi-group-table-row': !kpiInformation.KPIGroupGuid,
                    }"
                  >
                    <td style="width: 14%">{{ kpiInformation.Type }}</td>
                    <td style="width: 43%">{{ kpiInformation.Text }}</td>
                    <td style="width: 43%" class="nopadding">
                      <div class="form-group">
                        <textarea
                          rows="1"
                          maxlength="1000"
                          type="text"
                          class="form-control text-center textarea-kpi-translations autoExpand"
                          v-model="kpiInformation.Translation"
                          :placeholder="kpiInformation.InheritedTranslation"
                          @input="isTranslationDirty = true"
                        ></textarea>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-default"
            @click="closeKpiTranslationModal()"
          >
            {{ lang.KM3009 }}
          </button>
          <button
            type="button"
            class="btn btn-raised"
            :class="{
              'btn-warning': isTranslationDirty,
              'dialog-btn-primary': !isTranslationDirty,
            }"
            :disabled="
              !globals.isAccessAllowed('LoopOp_KPIsTranslation_Update') ||
              !isTranslationDirty
            "
            @click="saveKpiTranslations()"
          >
            {{ lang.KM3000 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Select2 from "../Tools/Select2";

export default {
  name: "KPIManagementTranslateModal",
  components: { Select2 },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#translateKpiDialog").on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });
  },
  watch: {
    showDialog() {
      if (this.showDialog) this.openTranslateKpiDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  props: ["showDialog", "client", "projects", "initialProject"],
  data() {
    return {
      selectedLocaleCode: "",
      selectedProject: "",
      searchKpiString: "",
      kpiTranslations: [],
      filteredKpiTranslations: [],
      avaibleLocaleList: [],
      isTranslationDirty: false,
      isInitialSort: false,
      currentSort: { key: "Type", asc: true },
      lang: {
        KM3000: "Save",
        KM3001: "KPI Translation",
        KM3002: "Language selection",
        KM3003: "Please choose a language...",
        KM3004: "Search...",
        KM3005: "Type",
        KM3006: "Text",
        KM3007: "Translation",
        KM3008: "Client",
        KM3009: "Close",
        KM3010: "Discard changes",
        KM3011: "Yes",
        KM3012: "No",
        KM3013: "There are unsaved changes. Do you want to proceed?",
        KM3014: "Reset sort",
        KM3015: "Project",
        KM3016: "Please select a project...",
      },
    };
  },
  methods: {
    correctTextareaHeight() {
      this.$nextTick(() => {
        let textareas = document.getElementsByClassName("autoExpand");
        for (let i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },
    openTranslateKpiDialog() {
      $("#translateKpiDialog").modal("show");
      this.initTranslateKpiDialog();
      this.getAvailableLocaleList();
    },
    initTranslateKpiDialog() {
      this.selectedLocaleCode = "";
      this.selectedProject = this.initialProject ? this.initialProject : "";
      this.searchKpiString = "";
      this.isTranslationDirty = false;
      this.isInitialSort = false;
      this.kpiTranslations = [];
      this.filteredKpiTranslations = [];
    },
    closeKpiTranslationModal() {
      if (this.isTranslationDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", () => {
          $("#translateKpiDialog").modal("hide");
        });
        return;
      }
      $("#translateKpiDialog").modal("hide");
    },
    getAvailableLocaleList() {
      let queryString = `api/KPITranslation/${this.client.clientGuid}/AvailableLocales`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.avaibleLocaleList = !_.isEmpty(data) ? data : [];
          this.$nextTick(() => {
            $("#selectLocale").val("").trigger("change");
          });
        },
        error: () => {
          console.error(
            "Available locale list access failed in getAvailableLocaleList()"
          );
          this.globals.showErrorSnackbar("Available locale list access failed");
        },
      });
    },
    selectedLocaleChanged(value, event) {
      if (!value) return;
      if (this.isTranslationDirty) {
        this.globals.$emit(
          "openGlobalUnsavedChangesDialog",
          () => {
            this.selectedLocaleCode = value;
            this.getKpiTranslations();
          },
          () => {
            $(event.target).val(this.selectedLocaleCode).trigger("change");
          }
        );
        return;
      }
      this.selectedLocaleCode = value;
      this.getKpiTranslations();
    },
    orderTableByColumn(orderProp) {
      if (!orderProp && !this.currentSort.key) return;

      if (orderProp) {
        this.currentSort.key === orderProp
          ? (this.currentSort.asc = !this.currentSort.asc)
          : (this.currentSort = { asc: true, key: orderProp });
      }

      this.isInitialSort = true;

      const sortFunction = (kpi) => {
        if (typeof kpi[this.currentSort.key] === "string") {
          return kpi[this.currentSort.key].toLowerCase();
        }
        return kpi[this.currentSort.key];
      };
      this.filteredKpiTranslations = _.orderBy(
        this.filteredKpiTranslations,
        [sortFunction],
        [this.currentSort.asc ? "asc" : "desc", "asc"]
      );
    },
    showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    doFiltering() {
      if (!this.searchKpiString)
        this.filteredKpiTranslations = this.kpiTranslations;

      let words = this.searchKpiString.split(" ");
      let keys = ["Type", "Text", "Translation", "InheritedTranslation"];

      const kpiFilter = (kpi) => {
        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              kpi[key] &&
              kpi[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };

      this.filteredKpiTranslations = !_.isEmpty(this.kpiTranslations)
        ? this.kpiTranslations.filter(kpiFilter)
        : [];
      this.currentSort.asc = !this.currentSort.asc;
      this.getInitialSort();
    },
    getKpiTranslations() {
      if (!this.client.clientGuid || !this.selectedLocaleCode) {
        this.kpiTranslations = [];
        this.doFiltering();
        return;
      }
      let queryString = `api/KPITranslation/${this.client.clientGuid}?LocaleCode=${this.selectedLocaleCode}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.kpiTranslations = !_.isEmpty(data) ? data : [];
          this.isTranslationDirty = false;
          this.doFiltering();
          this.correctTextareaHeight();
        },
        error: () => {
          console.error(
            "KPI Translations access failed in getKpiTranslations()"
          );
          this.globals.showErrorSnackbar("KPI Translations access failed");
        },
      });
    },
    saveKpiTranslations() {
      let queryString = `api/KPITranslation/${this.client.clientGuid}?LocaleCode=${this.selectedLocaleCode}`;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: JSON.stringify(this.kpiTranslations),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.globals.showSuccessSnackbar("KPI Translation update successful");
          this.isTranslationDirty = false;
        },
        error: () => {
          console.error("Error on PUT in saveKpiTranslations()");
          this.globals.showErrorSnackbar("KPI Translation update failed");
        },
      });
    },
    getInitialSort() {
      this.isInitialSort = false;
      // kpi groups
      let orderByKpiGroupType = [
        "KPIGroupCode",
        "KPIGroupShortText",
        "KPIGroupLongText",
      ];
      let kpiGroups = this.filteredKpiTranslations.filter(
        (kpi) => !kpi.KPIGroupGuid
      );
      this.sortElementsBy(kpiGroups, orderByKpiGroupType);
      // kpi
      let orderByKpiType = ["KPICode", "KPIShortText", "KPILongText"];
      let kpis = this.filteredKpiTranslations.filter((kpi) => kpi.KPIGroupGuid);
      this.sortElementsBy(kpis, orderByKpiType);

      kpis.forEach((kpi, index) => {
        let idx = _.findLastIndex(
          kpiGroups,
          (kpiGroup) => kpiGroup.Guid === kpi.KPIGroupGuid
        );
        kpiGroups.splice(idx + (index % 3) + 1, 0, kpi);
      });

      this.filteredKpiTranslations = kpiGroups;
    },
    sortElementsBy(elementsToSort, sortBy) {
      elementsToSort.sort((a, b) => {
        if (a.Guid > b.Guid) return 1;
        if (a.Guid < b.Guid) return -1;

        if (a.Guid === b.Guid) {
          if (sortBy.indexOf(a.Type) > sortBy.indexOf(b.Type)) return 1;
          if (sortBy.indexOf(a.Type) < sortBy.indexOf(b.Type)) return -1;
          if (sortBy.indexOf(a.Type) === sortBy.indexOf(b.Type)) return 0;
        }
      });
    },
  },
};
</script>

<style scoped>
#translateKpiDialog .modal-body {
  height: calc(100vh - 190px);
  padding-bottom: 0;
  padding-top: 12px;
}
#translateKpiDialog .modal-content {
  background-color: #eeeeee;
}
#translateKpiDialog .modal-dialog {
  width: calc(100vw - 200px);
}
.textarea-kpi-translations {
  display: block;
  overflow: hidden;
  margin: 0;
}
tbody {
  height: calc(100vh - 418px);
}

.kpi-group-table-row {
  background: rgb(248, 248, 248);
}
</style>



// WEBPACK FOOTER //
// KPIManagementTranslateModal.vue?25a8af73